import React from "react";

function UpperBonus(props) {
  return (
    <td className="scoresheet__cell">
      <p>{props.score}</p>
    </td>
  )
}

export default UpperBonus;